export const REDIRECTING_AUTH_LABEL = `Redirecting... You can also click %hereButton% to redirect.`;
export const REDIRECTING_AUTH_BUTTON_LABEL = 'here';
export const LOGIN_ERROR_LABEL = `We encountered an error. Click %loginLink% to return to login page.`;
export const REDIRECTING_LOGIN_AUTH = `Redirecting... You can also click %loginLink%.`;
